import { render } from "./template_mail_add.vue?vue&type=template&id=e2d9b346&scoped=true"
import script from "./template_mail_add.vue?vue&type=script&lang=js"
export * from "./template_mail_add.vue?vue&type=script&lang=js"

import "./template_mail_add.vue?vue&type=style&index=0&id=e2d9b346&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d9b346"]])

export default __exports__